import { useCallback, useEffect, useReducer, useRef } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { findDOMNode } from 'react-dom';
import Geosuggest from 'react-geosuggest';
import classNames from 'classnames';

import ButtonGroupOp from '../../components/ButtonGropOp';
import { addNotSupportedSuburbs } from '../../containers/Order/actions';
import { selectStoreConfig } from '../../containers/Layout/selectors';
import PoweredByComponent from '../PoweredByComponent';
import {
  getDeliveryCostFromApi,
  trimAddress,
} from '../../helpers/addressHelper';
import { getDineInObjects } from '../../helpers/getDineInObjects';
import { getMenuItemForInstore } from '../../helpers/getMenuItemForInstore';
import { firebaseAnalyticsNO } from '../../firebase';
import { eventNames } from 'configuration/eventNames';
import DineinSelectBox from 'components/ts/DineinSelectBox';
import isEqual from 'react-fast-compare';
import { getItemPrice } from '@next-order/next-order-engine';
export default function OrderPreView({
  currentOrder,
  incrementItemQuantity,
  decrementItemQuantity,
  incrementExtraQuantity,
  decrementExtraQuantity,
  updateOrderDeliveryAddress,
  allSuburbs,
  orderSetup,
  updateDeliveryPickupTime,
  deliveryTimes,
  pickUpTimes,
  isPickupOpen,
  isDeliveryOpen,
  userDetails,
  storeObj,
  deliveryAddressMissing,
  showErrorInTimeSelector,
  showErrorInTableSelector,
  toggleErrorStateForFutureTimeSelection,
  toggleErrorStateForTableSelection,

  menuItemSizes,
  menuItemSubModifiers,
  dineInObjects,
  floors,
  addTableToOrder,

  // halfHalfSetup,
  // currentUser,
}) {
  const accrParentRef = useRef(null);
  const geoSuggestRef = useRef(null);
  const storeConfig = useSelector(selectStoreConfig);
  const halfHalfSetup = useSelector(
    (state) => state.layoutReducer.halfHalfSetup
  );

  const [state, setLocalState] = useReducer((s, a) => ({ ...s, ...a }), {
    showAccordion: false,
    dineInObjects: [],
    floors: {},
    star: false,
    selectedTable: null,
  });

  const selectTime = useCallback(
    (timeObj) => {
      firebaseAnalyticsNO.logEvent(eventNames.SELECTED_TIME_OF_COLLECTION);
      setLocalState({ showAccordion: false });
      let deliveryDate = moment(
        `${timeObj.timeObjFinal} ${timeObj.displayForUse}`,
        'YYYY-MM-DD HH:mm A'
      );
      if (timeObj.alternateDisplay === 'ASAP')
        updateDeliveryPickupTime(deliveryDate, timeObj.shiftId, true, 0, false);
      else
        updateDeliveryPickupTime(deliveryDate, timeObj.shiftId, false, 0, true);

      toggleErrorStateForFutureTimeSelection(false);
    },
    [toggleErrorStateForFutureTimeSelection, updateDeliveryPickupTime]
  );

  const updateSelectedTimeIfItIsInPast = useCallback(
    (order, availableTimes) => {
      if (order && order.deliveryDate && availableTimes && orderSetup) {
        let today = moment(
          moment().tz(storeConfig.timeZone).format('YYYY-MM-DD HH:mm'),
          'YYYY-MM-DD HH:mm'
        );
        if (order.orderType === '1')
          today.add(
            orderSetup && orderSetup.pickUpTime
              ? Number(orderSetup.pickUpTime)
              : 0,
            'minutes'
          );
        else
          today.add(
            orderSetup && orderSetup.deliveryTime
              ? Number(orderSetup.deliveryTime)
              : 0,
            'minutes'
          );
        let delDate = moment(order.deliveryDate, 'YYYY-MM-DD HH:mm');

        //Detect if update required
        if (today.isAfter(delDate)) {
          if (
            availableTimes.length > 0 &&
            availableTimes[0].times &&
            availableTimes[0].times.length > 0
          ) {
            let timeObj = availableTimes[0].times[0];
            let deliveryDate = moment(
              `${timeObj.timeObjFinal} ${timeObj.displayForUse}`,
              'YYYY-MM-DD HH:mm A'
            );
            if (deliveryDate.isAfter(today)) {
              updateDeliveryPickupTime(
                deliveryDate,
                timeObj.shiftId,
                false,
                0,
                true
              );
            } else {
              updateDeliveryPickupTime(today, timeObj.shiftId, false, 0, false);
            }
          } else {
            // No time slot available
          }
        }
      } else if (
        order &&
        !order.deliveryDate &&
        availableTimes &&
        availableTimes[0] &&
        orderSetup
      ) {
        const asapTime = availableTimes[0].times[0];
        selectTime(asapTime);
      }
    },
    [orderSetup, selectTime, storeConfig.timeZone, updateDeliveryPickupTime]
  );

  const handleFetchDineInObjects = useCallback(async () => {
    if (!dineInObjects?.length) {
      const { storeId } = storeConfig ?? {};
      const response = await getDineInObjects(storeId);
      if (response && response.tables) {
        const { tables: dineInObjects, floors } = response;
        const number = currentOrder?.tableNumber;
        const floorLayoutId = currentOrder?.floorLayoutId;
        const dineInObject = dineInObjects.find(
          (item) =>
            (item.name === number || item.number === number) &&
            item.floorLayoutId === floorLayoutId
        );
        setLocalState({ dineInObjects, floors, selectedTable: dineInObject });
      }
    } else {
      if (dineInObjects?.length > 0) {
        const number = currentOrder?.tableNumber;
        const floorLayoutId = currentOrder?.floorLayoutId;
        const dineInObject = dineInObjects.find(
          (item) =>
            (item.name === number || item.number === number) &&
            item.floorLayoutId === floorLayoutId
        );
        setLocalState({
          selectedTable: dineInObject,
        });
      }
    }
  }, [
    currentOrder?.floorLayoutId,
    currentOrder?.tableNumber,
    dineInObjects,
    storeConfig,
  ]);

  useEffect(() => {
    const handleOutSideClickAccordion = (e) => {
      const aNode = findDOMNode(accrParentRef.current);
      if (aNode?.classList?.contains('active')) {
        if (!aNode || !aNode.contains(e.target)) {
          setLocalState({ showAccordion: false });
        }
      }
    };

    window.addEventListener('click', handleOutSideClickAccordion, false);
    const isDineIn = window.location.pathname.includes('/dine-in');
    if (isDineIn) setLocalState({ isDineIn });
    handleFetchDineInObjects();

    return () => {
      window.removeEventListener('click', handleOutSideClickAccordion, false);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (currentOrder?.tableNumber !== state.tableNumber) {
      setLocalState({ tableNumber: currentOrder.tableNumber });
      handleFetchDineInObjects();
    }
  }, [currentOrder?.tableNumber, state.tableNumber, handleFetchDineInObjects]);

  useEffect(() => {
    if (
      state.orderType !== currentOrder?.orderType ||
      !currentOrder?.deliveryDate
    ) {
      setLocalState({ orderType: currentOrder?.orderType });
      updateSelectedTimeIfItIsInPast(
        currentOrder,
        currentOrder.orderType === '2' ? deliveryTimes : pickUpTimes
      );
    }
  }, [
    currentOrder,
    deliveryTimes,
    pickUpTimes,
    state.orderType,
    updateSelectedTimeIfItIsInPast,
  ]);

  useEffect(() => {
    let selectedOrder = JSON.parse(JSON.stringify(currentOrder));
    let items = [];
    if (selectedOrder && selectedOrder.menuItems) {
      selectedOrder.menuItems.forEach((item) => {
        if (item.isHalf) {
          let betterHalfs = selectedOrder.menuItems.filter(
            (obj) =>
              obj.halfIndex === item.halfIndex && obj.whichHalf > item.whichHalf
          );
          /* if (!betterHalfs.length) {
            betterHalfs = selectedOrder.menuItems.filter((obj) => {
              return obj.halfIndex === item.halfIndex && obj._id === item._id;
            });
          } */
          if (betterHalfs && betterHalfs.length > 0) {
            item.urlHalf = betterHalfs[0].urlS3;
            item._idHalf = betterHalfs[0]._id;
            item.nameHalf = betterHalfs[0].name;
            item.itemTypeHalf = betterHalfs[0].itemType;
            item.baseModifierIdHalf = betterHalfs[0].baseModifierId;
            item.selectedSizesHalf = betterHalfs[0].selectedSizes;
            item.selectedModifiersHalf = betterHalfs[0].selectedModifiers;
            item.removedIngredientsHalf = betterHalfs[0].removedIngredients;
            item.selectedIngredientsHalf = betterHalfs[0].selectedIngredients;
            item.selectedExtraIngredientsHalf =
              betterHalfs[0].selectedExtraIngredients;
            items.push(item);
          }
        } else {
          items.push(item);
        }
      });
    }

    if (!isEqual(state.menuItems, items)) {
      setLocalState({ menuItems: items });
    }

    // eslint-disable-next-line
  }, [currentOrder]);

  const getGeoSuggestRenderItem = (suggestedAddress) => {
    const address =
      suggestedAddress?.label ||
      trimAddress({ mainAddress: suggestedAddress.description, storeConfig });

    return (
      <div>
        <span>{address}</span>
      </div>
    );
  };

  const selectTable = (table) => {
    setLocalState({
      selectedTable: table,
      showAccordion: false,
    });

    addTableToOrder(table);
    toggleErrorStateForTableSelection(false);
  };

  const toggleAccordion = (e, flag) => {
    if (flag) {
      setLocalState({
        showAccordion: !state.showAccordion,
      });
    }
    e.stopPropagation();
  };

  const updateDeliveryAddress = async (addObj) => {
    if (typeof addObj === 'undefined') {
      setLocalState({ star: false });
      return;
    }

    const { useRadiusBasedDeliveryAreaCalulation = false } = orderSetup ?? {};

    let sub = '',
      area = '',
      areaCode = '';
    const areasToMatchArray = [];
    if (addObj?.gmaps?.address_components?.length > 0) {
      addObj.gmaps.address_components.forEach((addressComponent) => {
        if (addressComponent?.types) {
          for (let i = 0; i < addressComponent.types.length; i++) {
            const type = addressComponent.types[i];
            if (type === 'postal_code') {
              areaCode = addressComponent.long_name
                ? addressComponent.long_name
                : '';
            }
            if (
              type === 'locality' ||
              type === 'route' ||
              type === 'postal_town'
            ) {
              areasToMatchArray.push(addressComponent.long_name);
              break;
            }
          }
        }
      });
    }

    if (useRadiusBasedDeliveryAreaCalulation) {
      const { isDeliverable, deliveryCost, minOrderValue } =
        await getDeliveryCostFromApi(storeConfig.storeId, addObj.location);

      if (!isDeliverable) {
        updateOrderDeliveryAddress('', '', areaCode, areasToMatchArray[0]);
        setLocalState({ deliveryAddrError: true });
        return;
      }

      setLocalState({ deliveryAddrError: false });
      updateOrderDeliveryAddress(
        addObj,
        { suburbId: '', deliveryCost, minOrderValue },
        areaCode,
        areasToMatchArray[0]
      );
      geoSuggestRef.current?.blur();
      return;
    }

    if (allSuburbs?.length > 0) {
      let supportedSubs = allSuburbs.filter((s) => {
        for (let i = 0; i < areasToMatchArray?.length; i++) {
          const areaName = areasToMatchArray[i];
          console.log('suburb', s);
          console.log('areaName', areaName, s.name);
          if (typeof areaName === 'string') {
            const doesMatch =
              areaName.toLowerCase().trim() === s.name.toLowerCase().trim();
            if (doesMatch) {
              area = areasToMatchArray[i];
              return true;
            }
          }
        }
        return false;
      });

      if (supportedSubs && supportedSubs.length > 0) {
        geoSuggestRef.current?.blur();
        setLocalState({ deliveryAddrError: false });
        updateOrderDeliveryAddress(addObj, supportedSubs[0], areaCode, area);
        return;
      }

      updateOrderDeliveryAddress('', '', areaCode, area);
      setLocalState({ deliveryAddrError: true });
      let username = null;
      let mobileNumber = null;
      let userId = null;
      if (userDetails) {
        if (userDetails.firstName && userDetails.lastName) {
          username = userDetails.firstName + ' ' + userDetails.lastName;
        }
        if (userDetails.mobileNumber) {
          mobileNumber = userDetails.mobileNumber;
        }
        if (userDetails.userId) {
          userId = userDetails.userId;
        }
      }
      if (addObj && sub && username && mobileNumber && userId) {
        addNotSupportedSuburbs(
          storeConfig,
          addObj,
          sub,
          username,
          mobileNumber,
          userId
        );
      }
    }

    // IF THERE ARE NO SUPPORTED SUBURBS
    updateOrderDeliveryAddress('', '', '', '');
    setLocalState({ deliveryAddrError: true });

    let username = null;
    let mobileNumber = null;
    let userId = null;
    if (userDetails) {
      if (userDetails.firstName && userDetails.lastName) {
        username = userDetails.firstName + ' ' + userDetails.lastName;
      }
      if (userDetails.mobileNumber) {
        mobileNumber = userDetails.mobileNumber;
      }
      if (userDetails.userId) {
        userId = userDetails.userId;
      }
    }

    if (addObj && sub && username && mobileNumber && userId) {
      addNotSupportedSuburbs(
        storeConfig,
        addObj,
        sub,
        username,
        mobileNumber,
        userId
      );
    }
  };

  const getLocalItemPrice = (itemObj) => {
    let itemPrice = Number(getItemPrice(itemObj, halfHalfSetup));
    const rowMenuItems = JSON.parse(JSON.stringify(currentOrder.menuItems));
    if (itemObj?.isHalf) {
      const otherHalf = itemObj.whichHalf === 1 ? 2 : 1;
      const othersHalf = rowMenuItems.filter((m) => {
        return m.halfIndex === itemObj.halfIndex && m.whichHalf === otherHalf;
      });
      if (othersHalf[0]) {
        itemPrice += Number(getItemPrice(othersHalf[0], halfHalfSetup));
      }
    }
    return itemPrice.toFixed(2);
  };

  const getNextFutureTimeDelivery = () => {
    if (deliveryTimes && deliveryTimes.length > 0) {
      let timeObj = deliveryTimes[0].times[0];
      let deliveryDate = moment(
        `${timeObj.timeObjFinal} ${timeObj.displayForUse}`,
        'YYYY-MM-DD HH:mm A'
      );
      return deliveryDate;
    }
  };

  const getNextFutureTimePickup = () => {
    if (pickUpTimes && pickUpTimes.length > 0) {
      let timeObj = pickUpTimes[0].times[0];
      let deliveryDate = moment(
        `${timeObj.timeObjFinal} ${timeObj.displayForUse}`,
        'YYYY-MM-DD HH:mm A'
      );
      return deliveryDate;
    }
  };

  const getTimeToDisplayDayPick = () => {
    // No time slot available
    if (pickUpTimes) {
      let today = moment(
        moment().tz(storeConfig.timeZone).format('YYYY-MM-DD hh:mm A'),
        'YYYY-MM-DD hh:mm A'
      );

      // if user has already choosen time slot
      if (currentOrder?.deliveryDate) {
        let delDate = moment(currentOrder.deliveryDate, 'YYYY-MM-DD HH:mm A');
        if (delDate.isSame(today, 'day')) {
          return `Today`;
        } else if (delDate.isSame(today.add(1, 'day'), 'day')) {
          return `Tomorrow`;
        } else
          return moment(currentOrder.deliveryDate, 'YYYY-MM-DD HH:mm A').format(
            'dddd'
          );
      } else if (isPickupOpen) {
        return 'Pickup';
      } else {
        var day = today.weekday() === 0 ? '7' : today.weekday().toString();
        let slotsForTheDay = pickUpTimes.filter((slotObj) => {
          return slotObj.day === day;
        });

        // If slots are available for a day
        if (slotsForTheDay.length > 0) {
          let delDate = getNextFutureTimePickup();
          if (delDate.isSame(today, 'day')) {
            return `Today`;
          } else if (delDate.isSame(today.add(1, 'day'), 'day')) {
            return `Tomorrow`;
          } else return delDate.format('dddd');
        } else {
          return 'Closed';
        }
      }
    } else {
      return 'Pickup';
    }
  };

  const getTimeToDisplayTimePick = () => {
    let timePickObj = {
      isDisplay: true,
      timeToDisplay: '15 minutes',
    };

    if (!pickUpTimes || !orderSetup) {
      return timePickObj;
    }

    let today = moment(
      moment().tz(storeConfig.timeZone).format('YYYY-MM-DD hh:mm A'),
      'YYYY-MM-DD hh:mm A'
    );

    var day = today.format(`E`);

    let slotsForTheDay = pickUpTimes.filter((slotObj) => {
      return slotObj.day === day;
    });

    // If slots are available for a day
    if (
      (slotsForTheDay.length > 0 &&
        orderSetup &&
        !orderSetup.isPreOrderingEnabled) ||
      (orderSetup && orderSetup.isPreOrderingEnabled && pickUpTimes.length > 0)
    ) {
      if (
        currentOrder &&
        currentOrder.deliveryDate &&
        currentOrder.isFutureDeliveryDate
      ) {
        timePickObj.timeToDisplay = moment(
          currentOrder.deliveryDate,
          'YYYY-MM-DD HH:mm A'
        ).format('hh:mm A');
        return timePickObj;
      } else if (isPickupOpen && orderSetup) {
        if (parseInt(orderSetup.pickUpTime) < 60) {
          timePickObj.timeToDisplay = `${orderSetup.pickUpTime} Minutes`;
          return timePickObj;
        } else {
          let minutesT = parseInt(orderSetup.pickUpTime);
          var hours = Math.trunc(minutesT / 60);
          var minutes = minutesT % 60;
          if (minutes === 0) {
            timePickObj.timeToDisplay = `${hours} ${
              hours > 1 ? 'hours' : 'hour'
            }`;
            return timePickObj;
          } else {
            timePickObj.timeToDisplay = `${hours}h : ${minutes}m`;
            return timePickObj;
          }
        }
      } else {
        timePickObj.timeToDisplay = 'Select Time';
        return timePickObj;
      }
    } else {
      timePickObj.isDisplay = false;
      timePickObj.timeToDisplay = `Reopen`;
      return timePickObj;
    }
  };

  const getTimeToDisplayDayDel = () => {
    // No time slot available
    if (deliveryTimes) {
      let today = moment(
        moment().tz(storeConfig.timeZone).format('YYYY-MM-DD hh:mm A'),
        'YYYY-MM-DD hh:mm A'
      );
      // if user has already choosen time slot
      if (currentOrder && currentOrder.deliveryDate) {
        let delDate = moment(currentOrder.deliveryDate, 'YYYY-MM-DD HH:mm A');
        if (delDate.isSame(today, 'day')) {
          return `Today`;
        } else if (delDate.isSame(today.add(1, 'day'), 'day')) {
          return `Tomorrow`;
        } else return delDate.format('dddd');
      } else if (isDeliveryOpen) {
        return 'Delivery';
      } else {
        var day = today.weekday() === 0 ? '7' : today.weekday().toString();
        let slotsForTheDay = deliveryTimes.filter((slotObj) => {
          return slotObj.day === day;
        });

        // If slots are available for a day
        if (slotsForTheDay.length > 0) {
          let delDate = moment(getNextFutureTimeDelivery());
          if (delDate.isSame(today, 'day')) {
            return `Today`;
          } else if (delDate.isSame(today.add(1, 'day'), 'day')) {
            return `Tomorrow`;
          } else return delDate.format('dddd');
        } else {
          return 'Closed';
        }
      }
    } else {
      return 'Delivery';
    }
  };

  const getTimeToDisplayTimeDel = () => {
    let timeDelObj = {
      isDisplay: true,
      timeToDisplay: '2 Hours',
    };

    if (!deliveryTimes || !orderSetup) {
      return timeDelObj;
    }

    let today = moment(
      moment().tz(storeConfig.timeZone).format('YYYY-MM-DD hh:mm A'),
      'YYYY-MM-DD hh:mm A'
    );

    var day = today.format(`E`);

    let slotsForTheDay = deliveryTimes.filter((slotObj) => {
      return slotObj.day === day;
    });

    // If slots are available for a day
    if (
      (slotsForTheDay.length > 0 &&
        orderSetup &&
        !orderSetup.isPreOrderingEnabled) ||
      (orderSetup &&
        orderSetup.isPreOrderingEnabled &&
        deliveryTimes.length > 0)
    ) {
      if (
        currentOrder &&
        currentOrder.deliveryDate &&
        currentOrder.isFutureDeliveryDate
      ) {
        timeDelObj.timeToDisplay = moment(
          currentOrder.deliveryDate,
          'YYYY-MM-DD HH:mm A'
        ).format('hh:mm A');
        return timeDelObj;
      } else if (isDeliveryOpen && orderSetup) {
        if (parseInt(orderSetup.deliveryTime) < 60) {
          timeDelObj.timeToDisplay = `${orderSetup.deliveryTime} Minutes`;
          return timeDelObj;
        } else {
          let minutesT = parseInt(orderSetup.deliveryTime);
          var hours = Math.trunc(minutesT / 60);
          var minutes = minutesT % 60;
          if (minutes === 0) {
            timeDelObj.timeToDisplay = `${hours} ${
              hours > 1 ? 'hours' : 'hour'
            }`;
            return timeDelObj;
          } else {
            timeDelObj.timeToDisplay = `${hours}h : ${minutes}m`;
            return timeDelObj;
          }
        }
      } else {
        timeDelObj.timeToDisplay = 'Select Time';
        return timeDelObj;
      }
    } else {
      timeDelObj.isDisplay = false;
      timeDelObj.timeToDisplay = `Reopen`;
      return timeDelObj;
    }
  };

  const webkitOverflowScrollingFixD = (e) => {
    let target = e.currentTarget;
    let top = target.scrollTop;
    if (!top) target.scrollTop++;
    // in case clientHeight is fractional we need to floor the result
    if (top === ~~(target.scrollHeight - target.clientHeight))
      target.scrollTop--;
  };

  const getClasses = () => {
    if (state.showAccordion) {
      if (currentOrder.deliveryDate !== '') {
        return 'pickupbox active d';
      } else {
        return 'pickupbox active';
      }
    } else {
      if (currentOrder.deliveryDate !== '') {
        return 'pickupbox d';
      } else {
        return 'pickupbox';
      }
    }
  };

  const getPickUpClasses = () => {
    if (state.showAccordion) {
      if (currentOrder.deliveryDate !== '') {
        return 'pickupbox active d';
      } else {
        return 'pickupbox active';
      }
    } else {
      if (currentOrder.deliveryDate !== '') {
        if (showErrorInTimeSelector) {
          if (window.innerWidth > 991) {
            return 'pickupbox d error';
          } else {
            return 'pickupbox d';
          }
        } else {
          return 'pickupbox d';
        }
      } else {
        return 'pickupbox';
      }
    }
  };

  const { selectedTable, showAccordion } = state;
  const floorsData = state?.floors || floors;

  let storeLocation =
    window?.google?.maps && storeObj?.addressLocation
      ? new window.google.maps.LatLng(
          storeObj.addressLocation.lat,
          storeObj.addressLocation.long
        )
      : {};

  let pickupTimePicObj = getTimeToDisplayTimePick();
  let deliveryTimePicObj = getTimeToDisplayTimeDel();
  let menuItems = state.menuItems;

  if (menuItems && menuItems.length > 0) {
    menuItems.map((menuItem) => {
      if (menuItemSizes?.length || menuItemSubModifiers?.length) {
        const newMenuItemSizes = menuItemSizes.filter(
          (f) =>
            f.orderType === currentOrder.orderType &&
            f.menuItemId === menuItem._id
        );
        const newMenuItemSubModifiers = menuItemSubModifiers.filter(
          (f) =>
            f.orderType === currentOrder.orderType &&
            f.menuItemId === menuItem._id
        );

        return getMenuItemForInstore(
          menuItem,
          newMenuItemSizes,
          newMenuItemSubModifiers
        );
      } else {
        return menuItem;
      }
    });
  }

  return (
    <div className='deliveryWrap'>
      {/* Delivery Section */}
      {currentOrder.orderType === '2' && (
        <div className={getClasses()}>
          <div
            style={
              deliveryAddressMissing
                ? {
                    outline: '2px solid rgba(240, 0, 0, 0.5)',
                    borderRadius: '2px',
                  }
                : {}
            }
            className='pickupboxInnerRight'
          >
            {deliveryAddressMissing && (
              <span
                style={{
                  position: 'absolute',
                  bottom: 0,
                  transform: 'translateY(130%)',
                  color: 'rgba(240, 0, 0, 0.5)',
                }}
              >
                Please enter delivery address
              </span>
            )}
            <div className='pickImg'>
              <span className='icon-Search' />
            </div>
            <div
              className={
                currentOrder.deliveryCost < 1
                  ? 'pickRestNameD free'
                  : 'pickRestNameD'
              }
            >
              <Geosuggest
                country={`${storeConfig.countryIdentifier}`}
                ref={geoSuggestRef}
                onKeyDown={(e) => {
                  if (e.keyCode === 9) {
                    e.preventDefault();
                    return;
                  }
                }}
                onChange={(_value) => {
                  updateOrderDeliveryAddress('', '', '', '');
                }}
                type='search'
                location={storeLocation}
                radius={5000}
                initialValue={currentOrder.address && currentOrder.address}
                className='deliverySearchBox'
                placeholder='Enter delivery address'
                suggestsClassName='autoSuggestionWrap'
                minLength={3}
                highlightMatch={true}
                renderSuggestItem={getGeoSuggestRenderItem}
                onSuggestNoResults={() => setLocalState({ start: false })}
                onSuggestSelect={(addrs) => updateDeliveryAddress(addrs)}
                getSuggestLabel={(suggest) => {
                  const isCustomAddress =
                    suggest?.structured_formatting?.main_text &&
                    suggest?.structured_formatting?.secondary_text;
                  return trimAddress({
                    mainAddress: isCustomAddress
                      ? suggest?.structured_formatting?.main_text
                      : suggest?.description,
                    secondryAddress:
                      suggest?.structured_formatting?.secondary_text,
                    storeConfig,
                  })?.trim();
                }}
              />

              {currentOrder.address &&
              currentOrder.menuItems.length > 0 &&
              currentOrder.deliveryCost &&
              state.deliveryAddrError !== true ? (
                <div className='deliveryCost'>
                  {currentOrder.deliveryCost < 1 ? (
                    <span>Free</span>
                  ) : (
                    `${storeConfig.currency}${Number(
                      currentOrder.deliveryCost
                    ).toFixed(2)}`
                  )}
                </div>
              ) : (
                ''
              )}
            </div>
          </div>

          {/* Only Visible in Desktop View */}
          <div className='pickupboxInnerLeft hidden-xs hidden-sm'>
            <div
              className='deliveryAccordionWrap'
              onClick={(e) => toggleAccordion(e, deliveryTimePicObj.isDisplay)}
            >
              <div className='pickImg'>
                <span className='icon-Clock' />
              </div>
              <div
                className={`${
                  showErrorInTimeSelector
                    ? `pickName robMedium error`
                    : `pickName robMedium`
                }`}
              >
                {getTimeToDisplayDayDel()}
                <br />
                <span className='etaPick robLight'>
                  {deliveryTimePicObj.timeToDisplay}
                </span>
                {deliveryTimePicObj.isDisplay && (
                  <span className='rotateAccordion'>
                    <i className='thickcon-Up-Chevron' />
                  </span>
                )}
              </div>
            </div>
            <div
              className={
                showAccordion ? 'accordionMain active' : 'accordionMain'
              }
              ref={accrParentRef}
            >
              <div className='tabWrapMain'>
                {deliveryTimes &&
                  deliveryTimes.map((d, index) => (
                    <div key={index} className='tab'>
                      <input
                        type='checkbox'
                        name='tabs'
                        id={`tab-one${index}`}
                      />
                      <label htmlFor={`tab-one${index}`}>
                        {d.display}
                        <i className='icon-Down-Chevron' />
                      </label>
                      <div className='tab-content'>
                        <ul className='subTime'>
                          {d.times.length > 0 &&
                            d.times.map((t, ii) => (
                              <li onClick={() => selectTime(t)} key={ii}>
                                <div>{t.display}</div>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div
            className='error'
            style={{
              transform: 'translateY(-115%)',
              color: 'red',
              top: 0,
              position: 'absolute',
            }}
          >
            {state.deliveryAddrError &&
              `We do not deliver food at this address.`}
          </div>
        </div>
      )}

      {/* PickUp Section */}
      {currentOrder.orderType === '1' && (
        <div className={getPickUpClasses()}>
          <div className='pickupboxInnerRight'>
            <div className='pickImg'>
              <span className='icon-Location-Pin' />
            </div>
            <div className='pickRestName robMedium'>
              {storeConfig.name}
              <br />
              <span className='pickAddress robLight'>
                {storeConfig.address}
              </span>
            </div>
          </div>

          {/* Only Visible in Desktop Version*/}
          <div className='pickupboxInnerLeft hidden-xs hidden-sm'>
            <div
              className='deliveryAccordionWrap'
              onClick={(e) => toggleAccordion(e, pickupTimePicObj.isDisplay)}
            >
              <div className='pickImg'>
                <span className='icon-Clock' />
              </div>
              <div
                className={`${
                  showErrorInTimeSelector
                    ? `pickName robMedium error`
                    : `pickName robMedium`
                }`}
              >
                {getTimeToDisplayDayPick()}
                <br />
                <span className='etaPick robLight'>
                  {pickupTimePicObj.timeToDisplay}
                </span>
                {pickupTimePicObj.isDisplay && (
                  <span className='rotateAccordion'>
                    <i className='thickcon-Up-Chevron' />
                  </span>
                )}
              </div>
            </div>
            <div
              className={
                showAccordion ? 'accordionMain active' : 'accordionMain'
              }
              ref={accrParentRef}
            >
              <div className='tabWrapMain'>
                {pickUpTimes &&
                  pickUpTimes.map((d, index) => (
                    <div key={index} className='tab'>
                      <input
                        type='checkbox'
                        name='tabs'
                        id={`tab-one${index}`}
                      />
                      <label htmlFor={`tab-one${index}`}>
                        {d.display}
                        <i className='icon-Down-Chevron' />
                      </label>
                      <div className='tab-content'>
                        <ul className='subTime'>
                          {d.times.length > 0 &&
                            d.times.map((t, ii) => (
                              <li onClick={() => selectTime(t)} key={ii}>
                                <div>{t.display}</div>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tables Section */}
      <DineinSelectBox
        orderType={currentOrder.orderType}
        currentOrder={currentOrder}
        floorsData={floorsData}
        selectedTable={selectedTable}
        showAccordion={showAccordion}
        storeId={storeConfig.storeId}
        toggleAccordion={toggleAccordion}
        showErrorInTableSelector={showErrorInTableSelector}
        selectTable={selectTable}
      />

      {menuItems && menuItems.length > 0 && (
        <div
          className={classNames('pickOrOrderWrap', {
            singleItem:
              currentOrder.orderType === '3' &&
              orderSetup?.isDineInOn &&
              currentOrder?.specials?.length <= 0,
          })}
          onTouchEnd={(e) => webkitOverflowScrollingFixD(e)}
        >
          <div className='pickTab'>
            <div>
              <div className='tableWrap'>
                <div className='sidefixe1'>
                  <table className='cartTable'>
                    <tbody>
                      {menuItems.map((item, index) =>
                        item.isHalf ? (
                          <tr key={index} className='cartRow halfHalfOK'>
                            <td className='cItemImg'>
                              <img alt='' src={item.urlS3} />
                              <img alt='' src={item.urlHalf} />
                            </td>
                            <td className='cItemName'>
                              {`${item.name} / ${item.nameHalf}`}
                              <span className='cItemPrice'>
                                {storeConfig.currency}
                                {getLocalItemPrice(item)}
                              </span>
                            </td>
                            <td className='cItemQuantity'>
                              {item.selectedSizes &&
                                item.selectedSizes.map((size, indexSize) =>
                                  size.quantity && Number(size.quantity) > 0 ? (
                                    <div
                                      key={indexSize}
                                      className='cItemMoreInfo'
                                    >
                                      <div className='cItemCategory text-capitalize'>
                                        {!item.itemType || item.itemType === 0
                                          ? `${size.name}`
                                          : `${size.name} ${
                                              size.cName &&
                                              size.cName.length > 0
                                                ? `,${size.cName}`
                                                : ''
                                            }`}
                                        /
                                        {!item.itemTypeHalf ||
                                        item.itemTypeHalf === 0
                                          ? `${item.selectedSizesHalf
                                              .filter(
                                                (s) => Number(s.quantity) > 0
                                              )
                                              .map((m) => m.name)
                                              .join(' ')}`
                                          : `${item.selectedSizesHalf
                                              .filter(
                                                (s) => Number(s.quantity) > 0
                                              )
                                              .map((m) => m.name)
                                              .join(
                                                ' '
                                              )} ${item.selectedSizesHalf
                                              .filter(
                                                (s) => Number(s.quantity) > 0
                                              )
                                              .map((m) => m.cName)
                                              .join(' ')}`}
                                        {size.variants &&
                                          size.variants.filter(
                                            (f) => f.quantity > 0
                                          ).length > 0 &&
                                          `(${size.variants
                                            .filter((f) => f.quantity > 0)
                                            .map((v) => v.name)
                                            .join(',')})`}
                                      </div>

                                      <ButtonGroupOp
                                        quantity={
                                          item.isHalf
                                            ? parseInt(size.quantity * 2, 10)
                                            : size.quantity
                                        }
                                        increaseBtnHandler={
                                          incrementItemQuantity
                                        }
                                        decreaseBtnHandler={
                                          decrementItemQuantity
                                        }
                                        operation='addToOrder'
                                        clickedItem={size}
                                        mainItem={item}
                                        whichHalf='1'
                                      />
                                    </div>
                                  ) : (
                                    <div key={indexSize} />
                                  )
                                )}
                              {((item.selectedExtraIngredients &&
                                item.selectedExtraIngredients.length > 0) ||
                                (item.removedIngredients &&
                                  item.removedIngredients.length > 0)) && (
                                <div className='cItemMoreInfo'>
                                  <div className='cItemCategory spName'>
                                    {item.name}
                                  </div>
                                </div>
                              )}
                              {item.selectedExtraIngredients &&
                                item.selectedExtraIngredients.map(
                                  (extra, indexExtra) =>
                                    extra.quantity &&
                                    Number(extra.quantity) > 0 ? (
                                      <div
                                        key={indexExtra}
                                        className='cItemMoreInfo'
                                      >
                                        <div className=' cItemCategory text-capitalize'>
                                          <span className='visible-xs visible-sm'>
                                            Extra{' '}
                                          </span>
                                          {extra.name
                                            ? extra.name
                                            : extra.ingredientName}
                                        </div>
                                        <ButtonGroupOp
                                          quantity={extra.quantity}
                                          increaseBtnHandler={
                                            incrementExtraQuantity
                                          }
                                          decreaseBtnHandler={
                                            decrementExtraQuantity
                                          }
                                          operation='addToOrder'
                                          clickedItem={extra}
                                          mainItem={item}
                                          maxQuantity='2'
                                          whichHalf='1'
                                        />
                                      </div>
                                    ) : (
                                      <div key={indexExtra} />
                                    )
                                )}
                              {item.removedIngredients &&
                                item.removedIngredients.map((ing, indexIng) => (
                                  <div key={indexIng} className='cItemMoreInfo'>
                                    <div className='cItemCategory text-capitalize'>
                                      {`Remove ${
                                        ing.name ? ing.name : ing.ingredientName
                                      }`}
                                    </div>
                                  </div>
                                ))}
                              {((item.selectedExtraIngredientsHalf &&
                                item.selectedExtraIngredientsHalf.length > 0) ||
                                (item.removedIngredientsHalf &&
                                  item.removedIngredientsHalf.length > 0)) && (
                                <div className='cItemMoreInfo'>
                                  <div className='cItemCategory spName'>
                                    {item.nameHalf}
                                  </div>
                                </div>
                              )}
                              {item.selectedExtraIngredientsHalf &&
                                item.selectedExtraIngredientsHalf.map(
                                  (extra, indexExtra) =>
                                    extra.quantity &&
                                    Number(extra.quantity) > 0 ? (
                                      <div
                                        key={indexExtra}
                                        className='cItemMoreInfo'
                                      >
                                        <div className='cItemCategory text-capitalize'>
                                          <span className='visible-xs visible-sm'>
                                            Extra{' '}
                                          </span>
                                          {extra.name
                                            ? extra.name
                                            : extra.ingredientName}
                                        </div>
                                        <ButtonGroupOp
                                          quantity={extra.quantity}
                                          increaseBtnHandler={
                                            incrementExtraQuantity
                                          }
                                          decreaseBtnHandler={
                                            decrementExtraQuantity
                                          }
                                          operation='addToOrder'
                                          clickedItem={extra}
                                          mainItem={item}
                                          maxQuantity='2'
                                          whichHalf='2'
                                        />
                                      </div>
                                    ) : (
                                      <div key={indexExtra} />
                                    )
                                )}
                              {item.removedIngredientsHalf &&
                                item.removedIngredientsHalf.map(
                                  (ing, indexIng) => (
                                    <div
                                      key={indexIng}
                                      className='cItemMoreInfo'
                                    >
                                      <div className='cItemCategory text-capitalize'>
                                        {`Remove ${
                                          ing.name
                                            ? ing.name
                                            : ing.ingredientName
                                        }`}
                                      </div>
                                    </div>
                                  )
                                )}
                            </td>
                          </tr>
                        ) : (
                          <tr
                            key={index}
                            className={
                              item.name.length > 10
                                ? `cartRow ${
                                    item.name.trim().indexOf(' ') !== -1
                                      ? 'fine'
                                      : 'oneword'
                                  }`
                                : 'cartRow vtop'
                            }
                          >
                            <td className='cItemImg'>
                              <img alt='' src={item.urlS3} />
                            </td>
                            <td
                              className={
                                item.name.length > 17
                                  ? 'cItemName bigName'
                                  : 'cItemName'
                              }
                            >
                              {item.isHalf && 'Half '}
                              {item.name}
                              <span className='cItemPrice'>
                                {storeConfig.currency}
                                {getLocalItemPrice(item)}
                              </span>
                            </td>
                            <td className='cItemQuantity'>
                              {item.selectedSizes &&
                                item.selectedSizes.map((size, indexSize) =>
                                  size.quantity && Number(size.quantity) > 0 ? (
                                    <div
                                      key={indexSize}
                                      className='cItemMoreInfo'
                                    >
                                      <div className='cItemCategory text-capitalize'>
                                        {!item.itemType || item.itemType === 0
                                          ? `${size.name}`
                                          : `${size.name} ${
                                              size.cName &&
                                              size.cName.length > 0
                                                ? `,${size.cName}`
                                                : ''
                                            }`}
                                        {size.variants &&
                                          size.variants.filter(
                                            (f) => f.quantity > 0
                                          ).length > 0 &&
                                          `(${size.variants
                                            .filter((f) => f.quantity > 0)
                                            .map((v) => v.name)
                                            .join(',')})`}
                                      </div>
                                      <ButtonGroupOp
                                        quantity={
                                          item.isHalf
                                            ? parseInt(size.quantity * 2, 10)
                                            : size.quantity
                                        }
                                        increaseBtnHandler={
                                          incrementItemQuantity
                                        }
                                        decreaseBtnHandler={
                                          decrementItemQuantity
                                        }
                                        operation='addToOrder'
                                        clickedItem={size}
                                        mainItem={item}
                                        whichHalf='1'
                                      />
                                    </div>
                                  ) : (
                                    <div key={indexSize} />
                                  )
                                )}
                              {item.selectedExtraIngredients &&
                                item.selectedExtraIngredients.map(
                                  (extra, indexExtra) =>
                                    extra.quantity &&
                                    Number(extra.quantity) > 0 ? (
                                      <div
                                        key={indexExtra}
                                        className='cItemMoreInfo'
                                      >
                                        <div className='cItemCategory text-capitalize'>
                                          <span className='visible-xs visible-sm'>
                                            Extra{' '}
                                          </span>
                                          {extra.name
                                            ? extra.name
                                            : extra.ingredientName}
                                        </div>
                                        <ButtonGroupOp
                                          quantity={extra.quantity}
                                          increaseBtnHandler={
                                            incrementExtraQuantity
                                          }
                                          decreaseBtnHandler={
                                            decrementExtraQuantity
                                          }
                                          operation='addToOrder'
                                          clickedItem={extra}
                                          mainItem={item}
                                          maxQuantity='2'
                                          whichHalf='1'
                                        />
                                      </div>
                                    ) : (
                                      <div key={indexExtra} />
                                    )
                                )}
                              {item.removedIngredients &&
                                item.removedIngredients.map((ing, indexIng) => (
                                  <div key={indexIng} className='cItemMoreInfo'>
                                    <div className='cItemCategory text-capitalize'>
                                      {`Remove ${
                                        ing.name ? ing.name : ing.ingredientName
                                      }`}
                                    </div>
                                  </div>
                                ))}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <PoweredByComponent />
        </div>
      )}
    </div>
  );
}
